import '../sass/style.scss'

document.addEventListener('DOMContentLoaded', function () {
  const anchorLinks = document.querySelectorAll('a[href^="#"]')

  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const href = link.getAttribute('href')

      if (!href || href === '#') return

      const target = document.querySelector(href)

      if (!target) return

      e.preventDefault()

      const header = document.querySelector('header')
      const headerHeight = header ? header.offsetHeight : 0
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    })
  })

  const targets = document.querySelectorAll('.in-view')

  if (!targets.length) return

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
        }
      })
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0,
    },
  )

  targets.forEach(function (target) {
    observer.observe(target)
  })
})
